/* eslint-disable react/prop-types */
import Flag from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { token } from '@atlaskit/tokens';
import { FlagComponentProps } from './FlagTypes';

const GenericErrorFlag: React.FC<FlagComponentProps> = ({ onDismiss }) => {
  return (
    <Flag
      icon={
        <ErrorIcon
          label="Error"
          primaryColor={token('color.background.danger.bold')}
        />
      }
      appearance="normal"
      id={'GenericErrorFlag'}
      onDismissed={onDismiss}
      title={'Something went wrong'}
      description={'We couldn’t update your linked accounts.'}
      actions={[
        {
          content: 'Learn More',
          onClick: () => {
            window.open(
              'https://community.atlassian.com/forums/x/x/ba-p/2958563',
            );
          },
        },
      ]}
    />
  );
};

export default GenericErrorFlag;
